import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  markedList: [],
  ignoredList: [],
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const markedIgnoredCustomersSlice = createSlice({
  name: "markedIgnoredCustomers",
  initialState,
  reducers: {
    customersFetched: (state, action) => {
      const {marked, ignored} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.markedList = marked;
      state.ignoredList = ignored;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
